export interface FormattedErrorIssue {
  path: (string | number)[];
  message: string;
  code?: string;
}

export interface FormattedError {
  error: any;
  message: string;
  statusCode: number;
  data: any;
  /** Per-field Zod issues, when the server rejected via `{ ok: false, issues }` (report submit family). */
  issues?: FormattedErrorIssue[];
  isFormatted: boolean;
}

const formatError = (err: any): FormattedError => {
  let error = err.message || 'Something went wrong';
  let message = error;
  let statusCode = 500;
  let data;
  let issues;
  try {
    const res = err.response.data;
    error = res.error;
    message = res.message;
    statusCode = res.statusCode;
    data = res.data || res.details;
    issues = res.issues;
  } catch (e) {
    console.log('e:', e);
    // take default values
  }

  if (process.env.NODE_ENV !== 'production') {
    console.error(error);
  }

  return {
    error,
    message,
    statusCode,
    data,
    issues,
    isFormatted: true,
  };
};

export default formatError;
